import App from "@/App"
import "@/styles/global.css"
import ReactDOM from "react-dom/client"

ReactDOM.createRoot(document.getElementById("root")!).render(<App />)
